<template>
<div>
 <div class="hide-content"></div>
  <div class="login-form">
   
    <div class="text-center">
      <form @submit.prevent="emitConfirm">
        <img src="../../assets/logo-white.png" alt="logo" />
        <br />
        <input
          :class="erroring ? 'error-input' : ''"
          type="text"
          maxlength="10"
          placeholder="PIN"
          :value="pin"
          readonly
        />
        <br />
        <div class="pin">
          <button type="button" class="number" v-for="i in 9" @click="enterNum(i)">{{ i }}</button>
          <button type="button" class="number x" @click="pinBackspace">
            <font-awesome-icon icon="arrow-left" />
          </button>
          <button type="button" class="number" @click="enterNum(0)">0</button>
          <button class="number ok" type="submit">ОК</button>
        </div>
      </form>
      <br />
    </div>
  </div>
  </div>
</template>

<script>
import AuthAPI from "@/api/auth";

export default {
  data() {
    return {
      pin: "",
      erroring: false
    };
  },
  methods: {
    enterNum(n) {
      if (this.pin.length >= 10) return;
      this.pin = this.pin + `${n}`;
    },
    pinBackspace() {
      if (this.pin.length == 0) {
        this.$emit('close');
        return;
      }

      this.pin = this.pin.substring(0, this.pin.length - 1);
    },
    emitConfirm() {
      this.$emit('confirm', this.pin);
      this.pin = '';
    },
    playError() {
      this.erroring = true;

      setTimeout(() => {this.erroring = false}, 1000);
    }
  },
  mounted() {
    
  },
  components: {
    
  }
};
</script>


<style scoped>
.login-form {
  background: #191919;
  width: 350px;
  margin: 0 auto;
  border-radius: 30px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  padding: 35px 0 5px 0;
  position: absolute;
  z-index: 2;
  left: 0;
  right: 0;
}

.hide-content {
  height: 100%;
  width: 100%;
  position: fixed;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1;
  opacity: 1;
  top: 0;
  left: 0;
}

.pin {
  display: grid;
  grid-template-rows: 70px 70px 70px 70px;
  grid-template-columns: 70px 70px 70px;
  justify-content: center;
  touch-action: manipulation;
}

img {
  height: 70px;
  margin-bottom: 10px;
}

input {
  text-align: center;
  padding: 5px 22px 10px 22px;
  border-radius: 35px;
  outline: none;
  background: #474747;
  border: 1px solid rgba(0, 0, 0, 0.8);
  color: #fff !important;
  margin: 20px 0;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

@keyframes fade {
    from { opacity: 1.0; }
    50% { opacity: 0.5; }
    to { opacity: 1.0; }
}     

.error-input {
  animation: fade 1s infinite;
  color: red;
  border: 1px solid red;
}

.number {
  background: #ffffff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 35px;
  align-self: auto;
  margin: 8px;
  border: 0;
  transition: 0.3s;
  font-weight: 500;
  font-size: 22px;
  outline: none;
  touch-action: manipulation;
}

.number.ok {
  background: #129B81;
  color: white;
  border: 0;
  padding: 10px 10px 12px;
}

.number.x {
  background: #129B81;
  color: white;
}

.number:active,
.number:hover {
  background-color: #757575;
  color: #ffffff;
}
</style>